import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="blob bg-[#6D28D9]/15 h-[300px] w-[300px] top-0 right-0" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5">
          <div className="overline">About us</div>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3A] tracking-tighter leading-[1.08]"
          >
            A trusted global partner for content-driven organizations.
          </motion.h2>
        </div>

        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: 0.05 }}
            className="text-base sm:text-lg text-[#475569] leading-relaxed"
          >
            Since <span className="font-semibold text-[#0B1F3A]">2010</span>, Libros Consulting has been a trusted
            global partner for publishers, educational institutions, museums, enterprises, and content-driven
            organizations. We combine publishing expertise, accessibility, content management, and
            technology-driven innovation to deliver scalable, future-ready solutions that help organizations
            create, manage, and distribute high-quality content across print and digital platforms.
          </motion.p>

          <a
            data-testid="about-cta"
            href="#services"
            className="mt-8 inline-flex items-center gap-1.5 text-[#1F5EFF] font-semibold text-[15px] hover:gap-2.5 transition-all"
          >
            See what we do <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
